(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-multi-accord"] && !Shopify.designMode) return;
  try {
    
  $(".custom_accordian_button").click(function(){
    var accordionIndex = $(this).attr("class").match(/accord(\d+)/)[1];
    $(this).toggleClass('active_accordian');
  });

  $(".custom_accordian_button.accord1").click(function(){
     $(".not_accordian").toggleClass('hide_image');
  });

  $(".inner_accordian_button").click(function(){
    $(this).toggleClass('active_accordian');
  });

  class ImaTabbedContent extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-ima-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-ima-panel]'));
      this.scrollerElement = this.querySelector('.ima-tab-layout__tabs');

      if (!this.panels.length) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(tab.dataset.imaTab));
      });
    }

    activate(panelId) {
      let selectedTab = null;

      this.tabs.forEach((tab) => {
        const isSelected = tab.dataset.imaTab === panelId;
        tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        tab.classList.toggle('button--primary', isSelected);
        tab.classList.toggle('button--outline', !isSelected);
        if (isSelected) selectedTab = tab;
      });

      this.panels.forEach((panel) => {
        const isActive = panel.dataset.imaPanel === panelId;
        panel.hidden = !isActive;
        panel.classList.toggle('is-active', isActive);
      });

      this._scrollTabIntoCenter(selectedTab);
    }

    _scrollTabIntoCenter(tab) {
      if (!tab || !this.scrollerElement) return;

      const scroller = this.scrollerElement;
      if (scroller.scrollWidth <= scroller.clientWidth) return;

      scroller.scrollTo({
        behavior: 'smooth',
        left: tab.offsetLeft - scroller.clientWidth / 2 + tab.clientWidth / 2
      });
    }
  }

  if (!customElements.get('ima-tabbed-content')) {
    customElements.define('ima-tabbed-content', ImaTabbedContent);
  }

  } catch(e) { console.error(e); }
})();
})();
